import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/cba/bx_ms2.png'
import _imports_1 from '../../assets/time.png'
import _imports_2 from '../../assets/time1.png'
import _imports_3 from '../../assets/time2.png'


const _hoisted_1 = { class: "pageYp" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "productYp_miaosha" }
const _hoisted_4 = { class: "per_pro" }
const _hoisted_5 = { class: "per_banner" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "per_info" }
const _hoisted_8 = { style: {"height":"72px"} }
const _hoisted_9 = {
  class: "per_div",
  style: {"margin-top":"0"}
}
const _hoisted_10 = { class: "per_time justify-center items-center" }
const _hoisted_11 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_12 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_13 = {
  key: 2,
  src: _imports_3,
  alt: ""
}
const _hoisted_14 = { class: "per_count" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("抢购中")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("即将开始")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("已抢完")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "",
      "left-text": "",
      "right-text": "兑换记录",
      onClickLeft: _ctx.onClickLeft,
      onClickRight: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goUrl())),
      class: "title"
    }, null, 8, ["onClickLeft"]),
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dhInfoList, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_row, { class: "items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "8" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: item.goodsImg,
                      alt: ""
                    }, null, 8, _hoisted_6)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, { span: "16" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(item.goodsName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_van_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_col, { span: "8" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                (item.dhStatus=='1')
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                                  : (item.dhStatus=='0')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                                _createElementVNode("span", {
                                  class: _normalizeClass(item.dhStatus=='0' ? 'time1' : (item.dhStatus == '2'? 'time2':''))
                                }, _toDisplayString(item.timePoint), 3)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_van_col, { span: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", null, _toDisplayString(item.instruction), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_van_col, { span: "10" }, {
                            default: _withCtx(() => [
                              (item.dhStatus=='1')
                                ? (_openBlock(), _createBlock(_component_van_button, {
                                    key: 0,
                                    type: "default",
                                    class: "buying",
                                    onClick: ($event: any) => (_ctx.jumpInfo(item.goodsId))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_15
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (item.dhStatus=='0')
                                  ? (_openBlock(), _createBlock(_component_van_button, {
                                      key: 1,
                                      type: "default",
                                      class: "coming",
                                      onClick: ($event: any) => (_ctx.jumpInfo(item.goodsId))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_16
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_van_button, {
                                      key: 2,
                                      type: "default",
                                      class: "none",
                                      onClick: ($event: any) => (_ctx.jumpInfo(item.goodsId))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_17
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ])
      ]))
    }), 256))
  ]))
}